<template>
    <div>
        <el-card>
            <div slot="header">
                <span class="top_title">原材料库存</span>
            </div>
            <div class="searchItem">
                <div class="search">
                    <span class="searchtips">产品编号:</span>
                    <el-input v-model="number" placeholder="" style="width: 160px;"></el-input>
                </div>
                <div class="search">
                    <span class="searchtips">产品名称:</span>
                    <el-input v-model="name" placeholder="" style="width: 160px;"></el-input>
                </div>
                <div class="search">
                    <span class="searchtips">属性:</span>
                    <el-input v-model="spec" placeholder="" style="width: 160px;"></el-input>
                </div>
                <div class="search">
                    <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
                </div>
            </div>
            <el-table :data="tableData" border>
                <el-table-column label="操作" width="80px" align="center">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="showDetail(row)">详情</el-button>
                    </template>
                </el-table-column>
                <template v-for="(col, index) in cols">
                    <template v-if="col.show">
                        <el-table-column :key="index" :prop="col.prop" :label="col.label" :width="col.width" align="left">
                            <template #header v-if="col.column">
                                {{col.label}}
                                <el-button circle icon="el-icon-top" size="mini" v-if="column==col.column&&order==true" type="primary" @click="setSort(col.column,true)"></el-button>
                                <el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
                                <el-button circle icon="el-icon-bottom" size="mini" v-if="column==col.column&&order==false" type="primary" @click="setSort(col.column,false)"></el-button>
                                <el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
                            </template>
                        </el-table-column>
                    </template>
                </template>
            </el-table>
            <div style="height:10px"></div>
            <el-pagination
                style="text-align: right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[20, 50, 120, 250]"
                :page-size="cp_pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :pager-count="5"
            >
            </el-pagination>
        </el-card>
        <el-dialog
            :visible.sync="storeInfoDialog"
            title="库存详情"
            width="60%"
        >
            <el-table :data="sInfo" border>
                <el-table-column label="仓库" prop="wname" align="left"></el-table-column>
                <el-table-column label="库存" prop="amount" align="left"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="storeInfoDialog = false"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data(){
        return{
            name:'',
            number:'',
            spec:'',
            column:'',
            order:'desc',
            total:0,
            tableData:[],
            currentPage:1,
            cp_pagesize:20,
            cols:[
                {
                    prop: 'number',
                    label: '编号',
                    show: true,
                },{
                    prop: 'name',
                    label: '产品',
                    show: true,
                },{
                    prop: 'spec1',
                    label: '属性1',
                    show: true,
                },{
                    prop: 'spec2',
                    label: '属性2',
                    show: true,
                },{
                    prop: 'price',
                    label: '单价',
                    show: true,
                },{
                    prop: 'packing',
                    label: '单位',
                    show: true,
                },{
                    prop: 'sname',
                    label: '供应商',
                    show: true,
                },{
                    prop: 'amount',
                    label: '库存',
                    show: true,
                },
            ],
            nowSearch:{
                limit:20,
                page:1,
            },
            storeInfoDialog:false,
            sInfo:[],
        }
    },
    created(){
        this.getInfo();
    },
    methods: {
        searchOrder:function(){
            this.currentPage = 1;
            this.nowSearch = {
                limit:this.cp_pagesize,
                page:1,
            }
            if(this.number.length>0){
                this.nowSearch.number = this.number;
            }
            if(this.name.length>0){
                this.nowSearch.name = this.name;
            }
            if(this.spec.length>0){
                this.nowSearch.spec = this.spec;
            }
            this.sortTime();
        },
        setSort(column,order){
            if(this.column==column&&this.order==order){
                this.column = '';
                this.order = '';
            }else{
                this.column = column;
                this.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.column){
                this.nowSearch.column = this.column;
                this.nowSearch.order = this.order?'asc':'desc';
            }else{
                delete this.nowSearch.column;
                delete this.nowSearch.order;
            }
            this.getInfo();
        },
        showDetail:function(item){
            let obj = {
                mid:item.id,
                msid:item.sid,
            }
            this.$api.listProductSpecStock(obj).then(res=>{
                if(res.data.code==1){
                    this.sInfo = res.data.data.data;
                    this.storeInfoDialog = true;
                }
            })
        },
        getInfo:function(){
            this.$api.listProductSpec(this.nowSearch).then(res=>{
                if(res.data.code==1){
                    let data = res.data.data;
                    this.total = data.total;
                    this.tableData = data.data;
                }
            })
        },
        handleSizeChange(e){
            this.cp_pagesize = e;
            this.searchOrder();
        },
        handleCurrentChange(e){
            this.currentPage = e;
            this.nowSearch.page = e;
            this.getInfo();
        },
    }
}
</script>